export default {
  rs: {
    loc_ti_ref_data: 20,
    typ_stanje_data: [1, 2],
    pos_standard_data: [0, 1],
    pos_nagib_data: [],
    typ_grejanje_default_data: 4,
    calc_order_data: "E;C;H",
    currency_data: "&euro;",
    currency_icon_data: "euro_ikonica",
    ga_gtag_data: "UA-30372466-1",
    typ_grejanje_cena_data: {
      1: 0.11,
      2: 0.09,
      3: 0.06,
      4: 0.04,
      5: 0.22,
      6: 0.04,
      7: 0.03,
      8: 0,
      9: 0.05,
      10: 0,
      11: 0,
      12: 0,
      13: 0,
      14: 0,
      15: 0,
      16: 0,
    },
    typ_grejanje_order_data: ["4", "1", "2", "3", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16"],
    app_tekuci_sklopovi_data: [
      "_1_3_20_0",
      "_1_3_25_0",
      "_1_3_30_0",
      "_1_4_25_0",
      "_1_4_30_0",
      "_1_4_38_0",
      "_1_4_45_0",
      "_1_4_51_0",
      "_1_4_60_0",
      "_1_5_19_0",
      "_1_5_25_0",
      "_1_5_29_0",
      "_1_5_38_0",
      "_1_6_10_3",
      "_1_6_19_3",
      "_1_6_25_5",
      "_1_6_29_3",
      "_1_6_29_5",
      "_1_7_0_0",
      "_1_8_0_5",
      "_1_8_0_6",
      "_1_8_0_8",
      "_1_9_30_0",
      "_1_9_50_0",
      "_1_9_60_0",
      "_1_12_0_0",
      "_1_13_25_0",
      "_1_14_10_0",
      "_1_15_10_3",
      "_1_15_10_5",
      "_1_15_10_7",
      "_1_15_12_5",
      "_1_15_12_8",
      "_1_15_19_3",
      "_1_15_19_5",
      "_1_15_25_3",
      "_1_15_29_5",
      "_1_16_30_0",
      "_1_16_38_0",
      "_1_19_0_0",
      "_1_20_0_4",
      "_1_20_0_5",
      "_1_20_0_6",
      "_1_20_0_8",
      "_5_1_0_0",
      "_5_2_0_0",
      "_5_3_0_0",
      "_5_4_16_3",
      "_5_5_0_0",
      "_5_5_0_12",
      "_5_6_15_0",
      "_7_1_0_0",
      "_7_2_20_0",
      "_7_3_0_0",
      "_7_5_0_0",
      "_7_5_0_15",
      "_7_5_0_30",
      "_7_6_0_3",
      "_7_6_0_6",
      "_7_6_0_7",
      "_10_1",
      "_10_2",
      "_10_3",
      "_10_4",
      "_10_5",
      "_10_6",
      "_10_7",
      "_10_8",
      "_10_9",
      "_10_10",
      "_10_11",
      "_10_12",
      "_10_13",
      "_10_14",
      "_10_15",
      "_10_16",
      "_10_17",
      "_10_18",
      "_10_19",
      "_10_20",
      "_10_21",
      "_10_22",
      "_10_23",
      "_10_24",
      "_13_1",
      "_13_2",
      "_13_3",
      "_13_4",
      "_13_5",
      "_13_6",
      "_13_7",
      "_13_8",
      "_18_1_16_0",
      "_18_2_0_0",
      "_18_3_0_0",
      "_18_4_0_0",
      "_18_5_0_0",
      "_18_6_0_0",
      "_18_6_0_12",
      "_18_7_20_10",
      "_18_8_20_10",
      "_18_101_16_0",
      "_18_102_0_0",
      "_18_103_0_0",
      "_18_104_0_0",
      "_18_105_0_0",
      "_18_106_0_0",
      "_18_106_0_12",
      "_18_107_20_10",
      "_18_108_20_10",
      "_19_2_0_0",
      "_19_3_0_0",
      "_19_4_0_0",
      "_19_5_0_0",
      "_19_6_0_0",
      "_19_7_0_0",
      "_19_8_0_0",
      "_19_9_0_0",
      "_19_9_0_6",
      "_19_9_0_8",
      "_19_10_0_0",
      "_19_10_0_2",
      "_19_10_0_3",
      "_19_10_0_6",
      "_19_11_20_2",
      "_20_1_50_0",
      "_20_1_60_0",
      "_20_2_25_0",
      "_20_2_38_0",
      "_20_2_45_0",
      "_20_2_51_0",
      "_20_2_60_0",
      "_20_3_20_0",
      "_20_3_25_0",
      "_20_3_30_0",
      "_20_4_20_5",
      "_20_4_25_5",
      "_20_4_30_5",
      "_21_1_0_0",
      "_21_2_0_0",
      "_21_3_0_0",
      "_21_4_0_3",
      "_21_4_0_4",
      "_21_4_0_5",
      "_21_4_0_6",
      "_21_4_0_8",
      "_21_4_0_10",
      "_21_4_0_12",
      "_19_1_20_0",
      "_19_9_0_12",
      "_19_9_0_2",
      "_19_9_0_3",
      "_21_4_0_0",
      "_21_4_0_0",
      "_5_5_0_18",
    ],
    app_country_pozicije_data: ["1", "5", "7", "10", "13", "18", "19", "20", "21"],
    typ_constdate_data: [
      "rs_001",
      "rs_002",
      "rs_003",
      "rs_004",
      "rs_005",
      "rs_006",
      "rs_007",
      "rs_008",
      "rs_new_house",
    ],
    typ_constdate_data_select: [
      "<1919",
      "1919-1945",
      "1946-1960",
      "1961-1970",
      "1971-1980",
      "1981-1990",
      "1991-2011",
      ">2012",
      null,
    ],
    app_sklopovi_default_data: {
      rs_001_1: "1_4_45_0",
      rs_001_5: "5_1_0_0",
      rs_001_7: "7_3_0_0",
      rs_001_18: "18_5_0_0",
      rs_001_19: "19_7_0_0",
      rs_001_20: "20_2_60_0",
      rs_001_21: "21_2_0_0",
      rs_001_10: "10_4",
      rs_001_13: "13_1",
      rs_002_1: "1_4_38_0",
      rs_002_5: "5_1_0_0",
      rs_002_7: "7_3_0_0",
      rs_002_18: "18_5_0_0",
      rs_002_19: "19_3_0_0",
      rs_002_20: "20_2_51_0",
      rs_002_21: "21_2_0_0",
      rs_002_10: "10_4",
      rs_002_13: "13_1",
      rs_003_1: "1_4_38_0",
      rs_003_5: "5_1_0_0",
      rs_003_7: "7_3_0_0",
      rs_003_18: "18_1_16_0",
      rs_003_19: "19_1_20_0",
      rs_003_20: "20_2_38_0",
      rs_003_21: "21_3_0_0",
      rs_003_10: "10_4",
      rs_003_13: "13_1",
      rs_004_1: "1_4_38_0",
      rs_004_5: "5_1_0_0",
      rs_004_7: "7_3_0_0",
      rs_004_18: "18_1_16_0",
      rs_004_19: "19_1_20_0",
      rs_004_20: "20_2_38_0",
      rs_004_21: "21_3_0_0",
      rs_004_10: "10_4",
      rs_004_13: "13_1",
      rs_005_1: "1_4_38_0",
      rs_005_5: "5_1_0_0",
      rs_005_7: "7_5_0_0",
      rs_005_18: "18_1_16_0",
      rs_005_19: "19_1_20_0",
      rs_005_20: "20_2_38_0",
      rs_005_21: "21_3_0_0",
      rs_005_10: "10_4",
      rs_005_13: "13_1",
      rs_006_1: "1_5_19_0",
      rs_006_5: "5_4_16_3",
      rs_006_7: "7_5_0_0",
      rs_006_18: "18_3_0_0",
      rs_006_19: "19_4_0_0",
      rs_006_20: "20_3_20_0",
      rs_006_21: "21_3_0_0",
      rs_006_10: "10_7",
      rs_006_13: "13_1",
      rs_007_1: "1_6_25_5",
      rs_007_5: "5_4_16_3",
      rs_007_7: "7_5_0_0",
      rs_007_18: "18_8_20_10",
      rs_007_19: "19_10_0_0",
      rs_007_20: "20_3_20_0",
      rs_007_21: "21_4_0_4",
      rs_007_10: "10_12",
      rs_007_13: "13_1",
      rs_008_1: "1_6_25_5",
      rs_008_5: "5_4_16_3",
      rs_008_7: "7_5_0_0",
      rs_008_18: "18_8_20_10",
      rs_008_19: "19_10_0_0",
      rs_008_20: "20_3_20_0",
      rs_008_21: "21_4_0_4",
      rs_008_10: "10_12",
      rs_008_13: "13_1",
      rs_new_house_1: "1_6_25_5",
      rs_new_house_5: "5_4_16_3",
      rs_new_house_7: "7_5_0_0",
      rs_new_house_18: "18_8_20_10",
      rs_new_house_19: "19_10_0_0",
      rs_new_house_20: "20_3_20_0",
      rs_new_house_21: "21_4_0_4",
      rs_new_house_10: "10_12",
      rs_new_house_13: "13_1",
    },
    app_country_materijal_data: {
      _1_1: {
        b: [4],
        c: [2, 12],
      },
      _1_2: {
        b: [4],
        c: [2, 12],
      },
      _1_3: {
        b: [4],
        c: [2, 12],
      },
      _1_4: {
        b: [4],
        c: [2, 12],
      },
      _1_5: {
        b: [4],
        c: [2, 12],
      },
      _1_6: {
        b: [4],
        c: [2, 12],
      },
      _1_7: {
        b: [4],
        c: [2, 12],
      },
      _1_8: {
        b: [4],
        c: [2, 12],
      },
      _1_9: {
        b: [4],
        c: [2, 12],
      },
      _1_10: {
        b: [4],
        c: [2, 12],
      },
      _1_11: {
        b: [4],
        c: [2, 12],
      },
      _1_12: {
        b: [4],
        c: [2, 12],
      },
      _1_13: {
        b: [4],
        c: [2, 12],
      },
      _1_14: {
        b: [4],
        c: [2, 12],
      },
      _1_15: {
        b: [4],
        c: [2, 12],
      },
      _1_16: {
        b: [4],
        c: [2, 12],
      },
      _1_17: {
        b: [4],
        c: [2, 12],
      },
      _1_18: {
        b: [4],
        c: [2, 12],
      },
      _1_19: {
        b: [4],
        c: [2, 12],
      },
      _1_20: {
        b: [4],
        c: [2, 12],
      },
      _5_1: {
        b: [8, 12],
        c: [9, 12],
      },
      _5_2: {
        b: [8, 12],
        c: [9, 12],
      },
      _5_3: {
        b: [8, 12],
        c: [9, 12],
      },
      _5_4: {
        b: [8, 12],
        c: [9, 12],
      },
      _5_5: {
        b: [8, 12],
        c: [9, 12],
      },
      _5_6: {
        b: [8, 12],
        c: [9, 12],
      },
      _7_1: {
        b: [10, 8, 1, 11],
        c: [9, 12],
      },
      _7_2: {
        b: [10, 8, 1, 11],
        c: [9, 12],
      },
      _7_3: {
        b: [10, 8, 11],
        c: [1, 9, 11],
      },
      _7_4: {
        b: [10, 8, 11],
        c: [1, 9, 11],
      },
      _7_5: {
        b: [10, 8, 1, 11],
        c: [9, 11],
      },
      _7_6: {
        b: [10, 1, 11],
        c: [9, 11],
      },
      _10_1: {
        b: [],
        c: [],
      },
      _10_2: {
        b: [],
        c: [],
      },
      _10_3: {
        b: [],
        c: [],
      },
      _10_4: {
        b: [],
        c: [],
      },
      _10_5: {
        b: [],
        c: [],
      },
      _10_6: {
        b: [],
        c: [],
      },
      _10_7: {
        b: [],
        c: [],
      },
      _10_8: {
        b: [],
        c: [],
      },
      _10_9: {
        b: [],
        c: [],
      },
      _10_10: {
        b: [],
        c: [],
      },
      _10_11: {
        b: [],
        c: [],
      },
      _10_12: {
        b: [],
        c: [],
      },
      _10_13: {
        b: [],
        c: [],
      },
      _10_14: {
        b: [],
        c: [],
      },
      _10_15: {
        b: [],
        c: [],
      },
      _10_16: {
        b: [],
        c: [],
      },
      _10_17: {
        b: [],
        c: [],
      },
      _10_18: {
        b: [],
        c: [],
      },
      _10_19: {
        b: [],
        c: [],
      },
      _10_20: {
        b: [],
        c: [],
      },
      _10_21: {
        b: [],
        c: [],
      },
      _10_22: {
        b: [],
        c: [],
      },
      _10_23: {
        b: [],
        c: [],
      },
      _10_24: {
        b: [],
        c: [],
      },
      _10_25: {
        b: [],
        c: [],
      },
      _10_26: {
        b: [],
        c: [],
      },
      _10_27: {
        b: [],
        c: [],
      },
      _10_28: {
        b: [],
        c: [],
      },
      _13_1: {
        b: [],
        c: [],
      },
      _13_2: {
        b: [],
        c: [],
      },
      _13_3: {
        b: [],
        c: [],
      },
      _13_4: {
        b: [],
        c: [],
      },
      _13_5: {
        b: [],
        c: [],
      },
      _13_6: {
        b: [],
        c: [],
      },
      _13_7: {
        b: [],
        c: [],
      },
      _13_8: {
        b: [],
        c: [],
      },
      _13_9: {
        b: [],
        c: [],
      },
      _18_1: {
        b: [12, 3, 12],
        c: [9, 12],
      },
      _18_2: {
        b: [12, 3, 12],
        c: [9, 12],
      },
      _18_3: {
        b: [12, 3, 12],
        c: [9, 12],
      },
      _18_4: {
        b: [12, 3, 12],
        c: [9, 12],
      },
      _18_5: {
        b: [12, 3, 12],
        c: [9, 12],
      },
      _18_6: {
        b: [12, 3, 12],
        c: [9, 12],
      },
      _18_7: {
        b: [12, 3, 12],
        c: [9, 12],
      },
      _18_8: {
        b: [12, 3, 12],
        c: [9, 12],
      },
      _18_101: {
        b: [12, 3, 12],
        c: [9, 12],
      },
      _18_102: {
        b: [12, 3, 12],
        c: [9, 12],
      },
      _18_103: {
        b: [12, 3, 12],
        c: [9, 12],
      },
      _18_104: {
        b: [12, 3, 12],
        c: [9, 12],
      },
      _18_105: {
        b: [12, 3, 12],
        c: [9, 12],
      },
      _18_106: {
        b: [12, 3, 12],
        c: [9, 12],
      },
      _18_107: {
        b: [12, 3, 12],
        c: [9, 12],
      },
      _18_108: {
        b: [12, 3, 12],
        c: [9, 12],
      },
      _19_1: {
        b: [12, 3, 12],
        c: [9],
      },
      _19_2: {
        b: [12, 3, 12],
        c: [9],
      },
      _19_3: {
        b: [12, 3, 12],
        c: [9],
      },
      _19_4: {
        b: [12, 3, 12],
        c: [9],
      },
      _19_5: {
        b: [12, 3, 12],
        c: [9],
      },
      _19_6: {
        b: [12, 3, 12],
        c: [9],
      },
      _19_7: {
        b: [12, 3, 12],
        c: [9],
      },
      _19_8: {
        b: [12, 3, 12],
        c: [9],
      },
      _19_9: {
        b: [12, 3, 12],
        c: [9],
      },
      _19_10: {
        b: [12, 3, 12],
        c: [9],
      },
      _19_11: {
        b: [12, 3, 12],
        c: [9],
      },
      _20_1: {
        b: [],
        c: [2, 12],
      },
      _20_2: {
        b: [],
        c: [2, 12],
      },
      _20_3: {
        b: [],
        c: [2, 12],
      },
      _20_4: {
        b: [],
        c: [2, 12],
      },
      _21_1: {
        b: [],
        c: [12, 3, 12],
      },
      _21_2: {
        b: [],
        c: [12, 3, 12],
      },
      _21_3: {
        b: [],
        c: [12, 3, 12],
      },
      _21_4: {
        b: [],
        c: [12, 3, 12],
      },
    },
    app_country_slike_data: {
      _1_1: {
        b: require("../src/assets/images/materijali/mat_1.png"),
        c: require("../src/assets/images/materijali/mat_6.png"),
      },
      _1_2: {
        b: require("../src/assets/images/materijali/mat_1.png"),
        c: require("../src/assets/images/materijali/mat_6.png"),
      },
      _1_3: {
        b: require("../src/assets/images/materijali/mat_1.png"),
        c: require("../src/assets/images/materijali/mat_6.png"),
      },
      _1_4: {
        b: require("../src/assets/images/materijali/mat_1.png"),
        c: require("../src/assets/images/materijali/mat_6.png"),
      },
      _1_5: {
        b: require("../src/assets/images/materijali/mat_1.png"),
        c: require("../src/assets/images/materijali/mat_6.png"),
      },
      _1_6: {
        b: require("../src/assets/images/materijali/mat_1.png"),
        c: require("../src/assets/images/materijali/mat_6.png"),
      },
      _1_7: {
        b: require("../src/assets/images/materijali/mat_1.png"),
        c: require("../src/assets/images/materijali/mat_6.png"),
      },
      _1_8: {
        b: require("../src/assets/images/materijali/mat_1.png"),
        c: require("../src/assets/images/materijali/mat_6.png"),
      },
      _1_9: {
        b: require("../src/assets/images/materijali/mat_1.png"),
        c: require("../src/assets/images/materijali/mat_6.png"),
      },
      _1_10: {
        b: require("../src/assets/images/materijali/mat_1.png"),
        c: require("../src/assets/images/materijali/mat_6.png"),
      },
      _1_11: {
        b: require("../src/assets/images/materijali/mat_1.png"),
        c: require("../src/assets/images/materijali/mat_6.png"),
      },
      _1_12: {
        b: require("../src/assets/images/materijali/mat_1.png"),
        c: require("../src/assets/images/materijali/mat_6.png"),
      },
      _1_13: {
        b: require("../src/assets/images/materijali/mat_1.png"),
        c: require("../src/assets/images/materijali/mat_6.png"),
      },
      _1_14: {
        b: require("../src/assets/images/materijali/mat_1.png"),
        c: require("../src/assets/images/materijali/mat_6.png"),
      },
      _1_15: {
        b: require("../src/assets/images/materijali/mat_1.png"),
        c: require("../src/assets/images/materijali/mat_6.png"),
      },
      _1_16: {
        b: require("../src/assets/images/materijali/mat_1.png"),
        c: require("../src/assets/images/materijali/mat_6.png"),
      },
      _1_17: {
        b: require("../src/assets/images/materijali/mat_1.png"),
        c: require("../src/assets/images/materijali/mat_6.png"),
      },
      _1_18: {
        b: require("../src/assets/images/materijali/mat_1.png"),
        c: require("../src/assets/images/materijali/mat_6.png"),
      },
      _1_19: {
        b: require("../src/assets/images/materijali/mat_1.png"),
        c: require("../src/assets/images/materijali/mat_6.png"),
      },
      _1_20: {
        b: require("../src/assets/images/materijali/mat_1.png"),
        c: require("../src/assets/images/materijali/mat_6.png"),
      },
      _5_1: {
        b: require("../src/assets/images/materijali/mat_2.png"),
        c: require("../src/assets/images/materijali/mat_8.png"),
      },
      _5_2: {
        b: require("../src/assets/images/materijali/mat_2.png"),
        c: require("../src/assets/images/materijali/mat_8.png"),
      },
      _5_3: {
        b: require("../src/assets/images/materijali/mat_2.png"),
        c: require("../src/assets/images/materijali/mat_8.png"),
      },
      _5_4: {
        b: require("../src/assets/images/materijali/mat_2.png"),
        c: require("../src/assets/images/materijali/mat_8.png"),
      },
      _5_5: {
        b: require("../src/assets/images/materijali/mat_2.png"),
        c: require("../src/assets/images/materijali/mat_8.png"),
      },
      _5_6: {
        b: require("../src/assets/images/materijali/mat_2.png"),
        c: require("../src/assets/images/materijali/mat_8.png"),
      },
      _7_1: {
        b: require("../src/assets/images/materijali/mat_3.png"),
        c: require("../src/assets/images/materijali/mat_8.png"),
      },
      _7_2: {
        b: require("../src/assets/images/materijali/mat_3.png"),
        c: require("../src/assets/images/materijali/mat_8.png"),
      },
      _7_3: {
        b: require("../src/assets/images/materijali/mat_4.png"),
        c: require("../src/assets/images/materijali/mat_7.png"),
      },
      _7_4: {
        b: require("../src/assets/images/materijali/mat_4.png"),
        c: require("../src/assets/images/materijali/mat_7.png"),
      },
      _7_5: {
        b: require("../src/assets/images/materijali/mat_3.png"),
        c: require("../src/assets/images/materijali/mat_11.png"),
      },
      _7_6: {
        b: require("../src/assets/images/materijali/mat_10.png"),
        c: require("../src/assets/images/materijali/mat_11.png"),
      },
      _10_1: {},
      _10_2: {},
      _10_3: {},
      _10_4: {},
      _10_5: {},
      _10_6: {},
      _10_7: {},
      _10_8: {},
      _10_9: {},
      _10_10: {},
      _10_11: {},
      _10_12: {},
      _10_13: {},
      _10_14: {},
      _10_15: {},
      _10_16: {},
      _10_17: {},
      _10_18: {},
      _10_19: {},
      _10_20: {},
      _10_21: {},
      _10_22: {},
      _10_23: {},
      _10_24: {},
      _10_25: {},
      _10_26: {},
      _10_27: {},
      _10_28: {},
      _13_1: {},
      _13_2: {},
      _13_3: {},
      _13_4: {},
      _13_5: {},
      _13_6: {},
      _13_7: {},
      _13_8: {},
      _13_9: {},
      _18_1: {
        b: require("../src/assets/images/materijali/mat_5.png"),
        c: require("../src/assets/images/materijali/mat_8.png"),
      },
      _18_2: {
        b: require("../src/assets/images/materijali/mat_5.png"),
        c: require("../src/assets/images/materijali/mat_8.png"),
      },
      _18_3: {
        b: require("../src/assets/images/materijali/mat_5.png"),
        c: require("../src/assets/images/materijali/mat_8.png"),
      },
      _18_4: {
        b: require("../src/assets/images/materijali/mat_5.png"),
        c: require("../src/assets/images/materijali/mat_8.png"),
      },
      _18_5: {
        b: require("../src/assets/images/materijali/mat_5.png"),
        c: require("../src/assets/images/materijali/mat_8.png"),
      },
      _18_6: {
        b: require("../src/assets/images/materijali/mat_5.png"),
        c: require("../src/assets/images/materijali/mat_8.png"),
      },
      _18_7: {
        b: require("../src/assets/images/materijali/mat_5.png"),
        c: require("../src/assets/images/materijali/mat_8.png"),
      },
      _18_8: {
        b: require("../src/assets/images/materijali/mat_5.png"),
        c: require("../src/assets/images/materijali/mat_8.png"),
      },
      _18_101: {
        b: require("../src/assets/images/materijali/mat_5.png"),
        c: require("../src/assets/images/materijali/mat_8.png"),
      },
      _18_102: {
        b: require("../src/assets/images/materijali/mat_5.png"),
        c: require("../src/assets/images/materijali/mat_8.png"),
      },
      _18_103: {
        b: require("../src/assets/images/materijali/mat_5.png"),
        c: require("../src/assets/images/materijali/mat_8.png"),
      },
      _18_104: {
        b: require("../src/assets/images/materijali/mat_5.png"),
        c: require("../src/assets/images/materijali/mat_8.png"),
      },
      _18_105: {
        b: require("../src/assets/images/materijali/mat_5.png"),
        c: require("../src/assets/images/materijali/mat_8.png"),
      },
      _18_106: {
        b: require("../src/assets/images/materijali/mat_5.png"),
        c: require("../src/assets/images/materijali/mat_8.png"),
      },
      _18_107: {
        b: require("../src/assets/images/materijali/mat_5.png"),
        c: require("../src/assets/images/materijali/mat_8.png"),
      },
      _18_108: {
        b: require("../src/assets/images/materijali/mat_5.png"),
        c: require("../src/assets/images/materijali/mat_8.png"),
      },
      _19_1: {
        b: require("../src/assets/images/materijali/mat_5.png"),
        c: require("../src/assets/images/materijali/mat_9.png"),
      },
      _19_2: {
        b: require("../src/assets/images/materijali/mat_5.png"),
        c: require("../src/assets/images/materijali/mat_9.png"),
      },
      _19_3: {
        b: require("../src/assets/images/materijali/mat_5.png"),
        c: require("../src/assets/images/materijali/mat_9.png"),
      },
      _19_4: {
        b: require("../src/assets/images/materijali/mat_5.png"),
        c: require("../src/assets/images/materijali/mat_9.png"),
      },
      _19_5: {
        b: require("../src/assets/images/materijali/mat_5.png"),
        c: require("../src/assets/images/materijali/mat_9.png"),
      },
      _19_6: {
        b: require("../src/assets/images/materijali/mat_5.png"),
        c: require("../src/assets/images/materijali/mat_9.png"),
      },
      _19_7: {
        b: require("../src/assets/images/materijali/mat_5.png"),
        c: require("../src/assets/images/materijali/mat_9.png"),
      },
      _19_8: {
        b: require("../src/assets/images/materijali/mat_5.png"),
        c: require("../src/assets/images/materijali/mat_9.png"),
      },
      _19_9: {
        b: require("../src/assets/images/materijali/mat_5.png"),
        c: require("../src/assets/images/materijali/mat_9.png"),
      },
      _19_10: {
        b: require("../src/assets/images/materijali/mat_5.png"),
        c: require("../src/assets/images/materijali/mat_9.png"),
      },
      _19_11: {
        b: require("../src/assets/images/materijali/mat_5.png"),
        c: require("../src/assets/images/materijali/mat_9.png"),
      },
      _20_1: {
        c: require("../src/assets/images/materijali/mat_6.png"),
      },
      _20_2: {
        c: require("../src/assets/images/materijali/mat_6.png"),
      },
      _20_3: {
        c: require("../src/assets/images/materijali/mat_6.png"),
      },
      _20_4: {
        c: require("../src/assets/images/materijali/mat_6.png"),
      },
      _21_1: {
        c: require("../src/assets/images/materijali/mat_5.png"),
      },
      _21_2: {
        c: require("../src/assets/images/materijali/mat_5.png"),
      },
      _21_3: {
        c: require("../src/assets/images/materijali/mat_5.png"),
      },
      _21_4: {
        c: require("../src/assets/images/materijali/mat_5.png"),
      },
    },
  },
};
